/**
 * Refcounted body scroll lock.
 *
 * Multiple modals/overlays can stack body scroll locks. The previous pattern
 * (each component snapshotting `document.body.style.overflow` on open and
 * restoring it on close) breaks when locks overlap: the second component
 * captures the first's `"hidden"` value as its "previous" state, then
 * restores it on close — leaving the body locked forever.
 *
 * Use `lockBodyScroll()` on mount and call the returned `unlock` on cleanup.
 * The body is only unlocked when every caller has released its lock.
 */

let lockCount = 0;

export function lockBodyScroll(): () => void {
  if (typeof document === "undefined") return () => {};
  if (lockCount === 0) {
    document.body.style.overflow = "hidden";
  }
  lockCount += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      // Always restore to empty string. Modals are the only legitimate caller,
      // so anything else stuck on `body.style.overflow` was already a leak.
      document.body.style.overflow = "";
    }
  };
}
